// Pure derivation from an EditorState to the URL-grammar query object the
// response-renderer consumes. Lives in shared so both the SPA (for the live
// share URL) and the server (for /s/:id replay of a saved share) can use it.
export function buildQuery(state) {
    const query = {};
    if (state.status !== 200)
        query.status = state.status;
    if (state.delay > 0)
        query.delay = state.delay;
    if ((state.chunks ?? 1) > 1)
        query.chunks = state.chunks;
    if ((state.chunkDelay ?? 0) > 0)
        query.chunkdelay = state.chunkDelay;
    const headerMap = {};
    for (const h of state.headers) {
        const name = h.name.trim();
        if (!name)
            continue;
        const value = h.value ?? '';
        const existing = headerMap[name];
        if (existing === undefined)
            headerMap[name] = value;
        else if (Array.isArray(existing))
            existing.push(value);
        else
            headerMap[name] = [existing, value];
    }
    if (Object.keys(headerMap).length > 0)
        query.h = headerMap;
    if (state.editorContent)
        query[state.payloadParam] = state.editorContent;
    return query;
}
